

function isMobile(){
    let device = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    if(device) {
        return true;
    }else{
        return false;
    }
}
function isSafari(){
    let device = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    if(device) {
        return true;
    }else{
        return false;
    }
}

export { isMobile,isSafari }